import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useIntake } from '../../context/IntakeContext';
import { RadioGroup } from '../ui/RadioGroup';
import { MascotPanel } from '../ui/MascotPanel';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';
import { Textarea } from '../ui/Textarea';
import { FileUpload } from '../ui/FileUpload';
import { PlusIcon, Trash2Icon } from 'lucide-react';
export function Step3Team() {
  const {
    data,
    updateData
  } = useIntake();
  const addTeamMember = () => {
    const newMember = {
      id: Date.now().toString(),
      name: '',
      role: '',
      department: '',
      bio: '',
      email: '',
      phone: '',
      linkedin: '',
      showOnSite: true,
      photo: '',
      expertise: '',
      sortOrder: ''
    };
    updateData({
      teamMembers: [...data.teamMembers, newMember]
    });
  };
  const removeTeamMember = (id: string) => {
    updateData({
      teamMembers: data.teamMembers.filter(m => m.id !== id)
    });
  };
  const updateTeamMember = (id: string, field: string, value: any) => {
    updateData({
      teamMembers: data.teamMembers.map(m => m.id === id ? {
        ...m,
        [field]: value
      } : m)
    });
  };
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -20
  }} className="max-w-3xl mx-auto space-y-8" data-id="element-377" data-mp="bdo0ezj3pzg9">
      <MascotPanel message="Mensen doen zaken met mensen! Een teampagina wekt vertrouwen. Wilt u uzelf of uw teamleden op de website tonen?" data-id="element-378" data-mp="kbzzzr1y47ku" />

      <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-8" data-id="element-379" data-mp="u3cr2gfx6tpt">
        <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-380" data-mp="z2pdj02vpyrv">
          Team & Medewerkers
        </h2>

        <div className="mb-8" data-id="element-381" data-mp="141to9v5gc4kb">
          <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-382" data-mp="142v92rc9s5f8">
            Wilt u teamleden op de website tonen?
          </label>
          <RadioGroup columns={2} value={data.showTeamOnWebsite} onChange={val => updateData({
          showTeamOnWebsite: val
        })} options={[{
          value: 'yes',
          label: 'Ja, we willen een teampagina'
        }, {
          value: 'no',
          label: 'Nee, dat is niet nodig'
        }, {
          value: 'later',
          label: 'Weet ik nog niet / later beslissen'
        }]} data-id="element-383" data-mp="ebk60j15hv7u" />
        </div>

        <AnimatePresence data-id="element-384" data-mp="122pl2vz9ojh3">
          {data.showTeamOnWebsite === 'yes' && <motion.div initial={{
          opacity: 0,
          height: 0
        }} animate={{
          opacity: 1,
          height: 'auto'
        }} exit={{
          opacity: 0,
          height: 0
        }} className="space-y-8 overflow-hidden" data-id="element-385" data-mp="38tp19oxi5xjb">
              <div className="pt-6 border-t border-gray-100" data-id="element-386" data-mp="1odqza79xydtm">
                <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-387" data-mp="19lyrqhge242g">
                  Wil je een foto uploaden van je teamleden?
                </label>
                <RadioGroup columns={1} value={data.teamHasPhotos} onChange={val => updateData({
              teamHasPhotos: val
            })} options={[{
              value: 'yes',
              label: "Ja, ik heb foto's"
            }, {
              value: 'no_need_shoot',
              label: "Nee, ik moet nog foto's maken"
            }, {
              value: 'no_later',
              label: 'Nee, die lever ik later aan'
            }]} data-id="element-388" data-mp="10lk6fi3fcoyy" />
              </div>

              {data.teamHasPhotos && <div className="space-y-6" data-id="element-389" data-mp="gx10j17lzapn">
                  <h3 className="text-lg font-bold text-gray-900" data-id="element-390" data-mp="h06pmgg8mcld">
                    Teamleden toevoegen
                  </h3>

                  {data.teamMembers.map((member, index) => <motion.div key={member.id} initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} className="p-6 bg-gray-50 rounded-2xl border border-gray-200 relative" data-id="element-391" data-mp="71zbe5dc28n2" data-mpi={index}>
                      <button onClick={() => removeTeamMember(member.id)} className="absolute top-4 right-4 p-2 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-full transition-colors" data-id="element-392" data-mp="3ffzm174vl3x6">
                        <Trash2Icon className="w-5 h-5" data-id="element-393" data-mp="1zyuuf91b0v3f" />
                      </button>

                      <h4 className="font-semibold text-gray-900 mb-4" data-id="element-394" data-mp="24wml5zq7qb61">
                        Teamlid {index + 1}
                      </h4>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4" data-id="element-395" data-mp="1c7fluyixphjq">
                        <Input label="Naam" value={member.name} onChange={e => updateTeamMember(member.id, 'name', e.target.value)} data-id="element-396" data-mp="1h6a7e88adk7j" />
                        <Input label="Functie" value={member.role} onChange={e => updateTeamMember(member.id, 'role', e.target.value)} data-id="element-397" data-mp="1q0f0kyaw77q8" />
                      </div>

                      <div className="mb-4" data-id="element-398" data-mp="1vum35ptfg1qj">
                        <Textarea label="Verhaaltje / Bio" value={member.bio} onChange={e => updateTeamMember(member.id, 'bio', e.target.value)} data-id="element-399" data-mp="1vtu6scs09zz7" />
                      </div>

                      {data.teamHasPhotos === 'yes' && <div data-id="element-400" data-mp="1cwt1equjhxuq">
                          <FileUpload label="Profielfoto" accept="image/*" uploadKey={`team_${member.id}`} value={member.photo} onChange={url => updateTeamMember(member.id, 'photo', url)} data-id="element-401" data-mp="1cxkxe2s1txlj" />
                        </div>}
                    </motion.div>)}

                  <Button variant="outline" onClick={addTeamMember} className="w-full border-dashed" data-id="element-402" data-mp="3aqx1frrxaiar">
                    <PlusIcon className="w-5 h-5 mr-2" data-id="element-403" data-mp="30t0vrfhr8fk1" />
                    Teamlid toevoegen
                  </Button>
                </div>}
            </motion.div>}
        </AnimatePresence>
      </div>
    </motion.div>;
}